import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-800 border-y border-white/5 relative overflow-hidden" data-id="element-133">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-134"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-6 md:mb-10" data-id="element-136">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12 md:w-16 md:h-16 text-gold-500 mx-auto" data-id="element-137">
            <path d="M9 21H15" data-id="element-138"></path>
            <path d="M10 21V17" data-id="element-139"></path>
            <path d="M14 21V17" data-id="element-140"></path>
            <path d="M12 17C12 17 12.5 14 15 12C16.5 10.8 17.5 9 17.5 7C17.5 4 15 1.5 12 1.5C9 1.5 6.5 4 6.5 7C6.5 9 7.5 10.8 9 12C11.5 14 12 17 12 17Z" data-id="element-141"></path>
          </svg>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-142">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-5 md:mb-8" data-id="element-143">
            El ADN del Éxito Visual
          </h2>

          <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-300 font-light leading-relaxed text-left" data-id="element-144">
            <p data-id="element-145">
              Después de analizar el ADN visual de canales como Ted-Ed y
              Kurzgesagt, descubrí que su éxito no reside en el software caro,
              sino en un <strong data-id="element-146">flujo de trabajo lógico</strong>. He hackeado
              ese proceso para crear el{' '}
              <span className="text-gold-500 font-medium" data-id="element-147">
                "Edutainment OS"
              </span>
              .
            </p>
            <div className="h-px w-full bg-gradient-to-r from-transparent via-gold-500/30 to-transparent my-5 md:my-8" data-id="element-148"></div>
            <p data-id="element-149">
              Este es un sistema híbrido diseñado para que el experto ponga la
              inteligencia y la IA ponga la ejecución de élite. Estamos hablando
              de automatizar la generación de metáforas visuales, guiones
              magnéticos y animaciones fluidas que antes solo eran accesibles
              para estudios de cine.
            </p>
            <p className="text-lg md:text-xl text-white font-serif italic text-center mt-5 md:mt-8" data-id="element-150">
              Hoy, ese poder está en tus manos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}